import './Contact.css';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import emailjs from 'emailjs-com';

const EMAILJS_SERVICE_ID = 'service_zbddlab';
const EMAILJS_TEMPLATE_NOTIFY = 'template_0e9038m';
const EMAILJS_PUBLIC_KEY = 'odTuOcd2Pwf9x2wX7';
/** ID e shabllonit "Auto-Reply" nga EmailJS → Email Templates (p.sh. template_abc123). Vendose në .env: REACT_APP_EMAILJS_TEMPLATE_AUTOREPLY=... */
const EMAILJS_TEMPLATE_AUTOREPLY = process.env.REACT_APP_EMAILJS_TEMPLATE_AUTOREPLY;

function getEmailJsErrorDetail(error) {
  if (error == null) return '';
  if (typeof error.message === 'string' && error.message.trim()) return error.message.trim();
  if (typeof error.text === 'string' && error.text.trim()) {
    const raw = error.text.trim();
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        if (typeof parsed.error === 'string' && parsed.error.trim()) return parsed.error.trim();
        if (typeof parsed.message === 'string' && parsed.message.trim()) return parsed.message.trim();
      }
    } catch {
      /* EmailJS nganjëherë kthen tekst të drejtpërdrejtë, jo JSON */
    }
    return raw;
  }
  if (typeof error.status === 'number' && error.status) return `HTTP ${error.status}`;
  return '';
}

function Contact() {
  const { t } = useTranslation();
  
  // State për form data
  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    company: '',
    phone: '',
    about: ''
  });
  
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });


  useEffect(() => {
    emailjs.init(EMAILJS_PUBLIC_KEY);
  }, []);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Handle form submission with EmailJS
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ type: '', text: '' });

    try {
      // Prepare template parameters
      const templateParams = {
        from_name: formData.fullname,
        /* Alias-e për shabllonet EmailJS që përdorin {{name}} / {{fullname}} në vend të {{from_name}} */
        name: formData.fullname,
        fullname: formData.fullname,
        company_name: 'Shala Accounting Team',
        from_email: formData.email,
        message: formData.about,
        reply_to: formData.email,
        company_email: 'info@shalaaccounting.com',
        company: formData.company || '',
        phone: formData.phone || '',
      };

      console.log('Sending email with params:', templateParams);

      // Send email using EmailJS
      const response = await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_NOTIFY,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );

      console.log('EmailJS response:', response);

      if (response.status === 200) {
        if (EMAILJS_TEMPLATE_AUTOREPLY) {
          try {
            await emailjs.send(
              EMAILJS_SERVICE_ID,
              EMAILJS_TEMPLATE_AUTOREPLY,
              templateParams,
              EMAILJS_PUBLIC_KEY
            );
          } catch (autoReplyError) {
            console.error('EmailJS auto-reply failed:', autoReplyError);
          }
        }
        setMessage({ type: 'success', text: t('contact.messageSentSuccess') });
        // Reset form
        setFormData({
          fullname: '',
          email: '',
          company: '',
          phone: '',
          about: ''
        });
      } else {
        throw new Error(`Failed to send message. Status: ${response.status}`);
      }
    } catch (error) {
      console.error('Error sending message:', error);
      const detail = getEmailJsErrorDetail(error);
      setMessage({
        type: 'error',
        text: detail
          ? t('contact.sendErrorWithDetail', { detail })
          : t('contact.sendError'),
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="contact-section" id="contact">
      <form className="contact-form" autoComplete="off" onSubmit={handleSubmit}>
        <h2 className="contact-title">{t('contact.title')}</h2>
        <p className="contact-desc">{t('contact.desc')}</p>
        
        {/* Message display */}
        {message.text && (
          <div className={`contact-message ${message.type}`}>
            {message.text}
          </div>
        )}
        
        <div className="contact-grid">
          <div className="contact-field">
            <input 
              type="text" 
              name="fullname" 
              placeholder={t('contact.fullname')} 
              value={formData.fullname}
              onChange={handleInputChange}
              required 
            />
          </div>
          <div className="contact-field">
            <input 
              type="email" 
              name="email" 
              placeholder={t('contact.email')} 
              value={formData.email}
              onChange={handleInputChange}
              required 
            />
          </div>
          <div className="contact-field">
            <input 
              type="text" 
              name="company" 
              placeholder={t('contact.company')} 
              value={formData.company}
              onChange={handleInputChange}
            />
          </div>
          <div className="contact-field">
            <input 
              type="text" 
              name="phone" 
              placeholder={t('contact.phone')} 
              value={formData.phone}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="contact-field contact-full">
          <textarea 
            name="about" 
            placeholder={t('contact.about')} 
            rows={3} 
            value={formData.about}
            onChange={handleInputChange}
            required
          ></textarea>
        </div>
        {/* <div className="contact-options">
          <label className="contact-file">
            <span role="img" aria-label="attach">📎</span> {t('contact.attach')}
            <input
              type="file"
              ref={fileInput}
              accept=".pdf,.docx,.odt,.ods,.pptx,.xlsx,.rtf,.txt"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
          </label>
          <span className="contact-file-desc">
            Please upload a file with the following extension: pdf, docx, odt, ods, pptx, xlsx, rtf, txt (max 5MB)
          </span>
        </div> */}

        <button 
          className="contact-btn" 
          type="submit"
          disabled={isLoading}
        >
          {isLoading ? t('contact.sending') : t('contact.send')}
        </button>
      </form>
    </section>
  );
}

export default Contact; 